var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlbum({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1632892576377,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 6188,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 102.4l0 819.2 921.6 0 0-819.2-921.6 0zM82.144 136.544l85.344 0 0 750.944-85.344 0 0-750.944zM935.456 887.456l-733.856 0 0-750.944 733.856 0 0 750.944z",
    "p-id": 6189
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M577.056 836.256c179.2 0 324.256-145.056 324.256-324.256s-145.056-324.256-324.256-324.256c-179.2 0-324.256 145.056-324.256 324.256s145.056 324.256 324.256 324.256zM577.056 221.856c160.416 0 290.144 129.696 290.144 290.144s-129.696 290.144-290.144 290.144c-160.416 0-290.144-129.696-290.144-290.144s129.696-290.144 290.144-290.144z",
    "p-id": 6190
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M577.056 614.4c56.32 0 102.4-46.08 102.4-102.4s-46.08-102.4-102.4-102.4c-56.32 0-102.4 46.08-102.4 102.4s46.08 102.4 102.4 102.4zM577.056 443.744c37.536 0 68.256 30.72 68.256 68.256s-30.72 68.256-68.256 68.256-68.256-30.72-68.256-68.256c0-37.536 30.72-68.256 68.256-68.256z",
    "p-id": 6191
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M594.144 512c0 9.44-7.648 17.056-17.056 17.056s-17.056-7.648-17.056-17.056c0-9.44 7.648-17.056 17.056-17.056s17.056 7.648 17.056 17.056z",
    "p-id": 6192
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlbum);
export default __webpack_public_path__ + "static/media/album.06355066.svg";
export { ForwardRef as ReactComponent };